import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import { Game } from 'config/types/game'
import Column from 'layout/Components/Column'
import React from 'react'
import { useAuth } from 'state/auth/hooks'
import styled from 'styled-components'
import BonusAdventure from './BonusAdventure'
import BonusWager from './BonusWager'
import Cashback from './Cashback'
import HUSDBonus from './HUSDBonus'
import LevelUpBonus from './LevelUpBonus'
import { useGameScreenBonusScale } from './styled'

const GameScreenBouns: React.FC<BoxProps & { game: Game }> = ({ game, ...props }) => {
  const { hasSession } = useAuth()
  const { elementRef, scaleVariant } = useGameScreenBonusScale()

  return (
    hasSession && (
      <StyledWrapper {...props}>
        <StyledWrapListBonus
          ref={elementRef}
          spacingRight={scaleVariant.spacingRight}
          afterRight={scaleVariant.afterRight}
          className="game-screen-bouns-list"
        >
          <BonusWager maxWidth={scaleVariant.containerBonusWidth} game={game} {...scaleVariant} />
          <LevelUpBonus maxWidth={scaleVariant.containerLevelUpWidth} {...scaleVariant} />
          <BonusAdventure maxWidth={scaleVariant.containerAdventureWidth} game={game} {...scaleVariant} />
          <HUSDBonus maxWidth={scaleVariant.containerHusd} {...scaleVariant} />
          <Cashback maxWidth={scaleVariant.containerCashback} {...scaleVariant} />
        </StyledWrapListBonus>
      </StyledWrapper>
    )
  )
}

const StyledWrapper = styled(Column)`
  border-radius: ${({ theme }) => theme.radii.small};
  background: rgba(35, 44, 61, 0.2);
  padding: 8px 12px;
  width: 100%;
  position: relative;

  ${({ theme }) => theme.mediaQueries.lg} {
    background: transparent;
    padding: 0;
  }
`

const StyledWrapListBonus = styled(Flex)<{ spacingRight: string; afterRight: string }>`
  width: 100%;
  flex-direction: column;

  .wrapper {
    width: 100%;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 0.33px solid rgba(84, 84, 88, 0.65);

    &:last-child {
      border-bottom: 0;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    flex-direction: row;

    .wrapper {
      width: 100%;
      margin: 0;
      padding: 0;
      border-bottom: 0;

      margin-right: ${({ spacingRight }) => spacingRight};

      position: relative;

      &:after {
        content: '';
        height: calc(100% - 20px);
        width: 1px;
        position: absolute;
        right: ${({ afterRight }) => afterRight};
        top: 50%;
        transform: translateY(-50%);
        background-color: ${({ theme }) => theme.colors.buttonBackgroundAlt2};
      }

      &:last-child {
        border-right: 0;
        margin-right: 0;
        padding-right: 0;

        &:after {
          content: '';
          display: none;
        }
      }
    }
  }
`

export default GameScreenBouns
